import { getFunctions, httpsCallable } from "firebase/functions";
import { getFirestore, doc, runTransaction } from "firebase/firestore";
const db = getFirestore();

const functions = getFunctions();

const emailModule = {
  state: () => ({
    status: undefined,
    error: undefined
  }),
  getters: {
    getEmailStatus: (state) => state.status,
    getEmailError: (state) => state.error
  },
  mutations: {
    setEmailStatus(state, status) {
      state.status = status;
    },
    setEmailError(state, error) {
      state.error = error;
    }
  },
  actions: {
    sendBookingEmail(context, booking) {
      console.log(`SENDING EMAIL: ${ booking }`);
      const sendFastQuote = httpsCallable(functions, 'sendFastQuote');
      sendFastQuote(booking)
      .then(function() {
        context.commit('setEmailStatus', 'SUCCESS');
      })
      .catch((error) => {
        context.commit('setEmailError', error);
        alert(error);
      });
    },
    cardMail(context, user){
      const sendCardMail = httpsCallable(functions, 'sendCardMail');
      sendCardMail(user)
      .then(() => console.log(user))
      .catch((error) => {
        console.log(error);
        context.commit('setEmailError', error);
      });
    },
    userMail(context, user){
      const sendUserMail = httpsCallable(functions, 'sendUserMail');
      sendUserMail(user)
      .catch((error) => {
        console.log(error);
        context.commit('setEmailError', error);
      });
    },
    async addTreeNum(context, data){
      const ref = doc(db, 'umthi', 'tree');
      await runTransaction(db, async(transaction) => {
        const getNum = await transaction.get(ref);
        let num = getNum.data().treeNum;
        num++;
        console.log(num);
        data.treeNumber = num;

        //sent umthi mail
        const sendUmthiMail = httpsCallable(functions, 'sendUmthiMail');
        await sendUmthiMail(data)
        .catch((error) => {
          console.log(error);
          context.commit('setEmailError', error);
        });

        //update tree num in database
        transaction.set(ref, { treeNum: num }, {merge: true});
      })
    }
    
  }
}

export default emailModule;